import React, { useState, useMemo } from 'react';
import { StoreLogoProps } from './StoreLogo.types';
import { getBorderRadius, getLogoDimension, getPlaceholderDimension } from './utils';
import { KarmaLogoWrapper, StoreLogoImage, StoreLogoWrap } from './StoreLogo.styles';

const StoreLogo: React.FC<StoreLogoProps> = ({
  src = '',
  size = 'medium',
  alt = 'logo',
  variant = 'circle',
  ...props
}) => {
  const placeholderDimension = useMemo(() => getPlaceholderDimension(size), [size]);
  const logoDimension = useMemo(() => getLogoDimension(size), [size]);
  const borderRadius = useMemo(() => getBorderRadius(variant), [variant]);

  const [showPlaceholder, setShowPlaceholder] = useState(false);

  const onErrorImageHandler = () => {
    setShowPlaceholder(true);
  };

  if (showPlaceholder) {
    return (
      <StoreLogoWrap
        {...props}
        $width={logoDimension}
        $height={logoDimension}
        $borderRadius={borderRadius}
      >
        <KarmaLogoWrapper width={placeholderDimension} variant="symbol" />
      </StoreLogoWrap>
    );
  }

  return (
    <StoreLogoWrap
      {...props}
      $width={logoDimension}
      $height={logoDimension}
      $borderRadius={borderRadius}
    >
      <StoreLogoImage
        width={logoDimension}
        height={logoDimension}
        onError={onErrorImageHandler}
        src={src}
        alt={alt}
      />
    </StoreLogoWrap>
  );
};

export default StoreLogo;
